export function getMeaningfulRouteText(value, routeShortName) {
  const normalizedValue = String(value || "").trim();
  const normalizedShortName = String(routeShortName || "").trim();

  if (!normalizedValue) {
    return null;
  }

  if (
    normalizedShortName &&
    normalizedValue.toLowerCase() === normalizedShortName.toLowerCase()
  ) {
    return null;
  }

  return normalizedValue;
}

export function getServiceDisplayName(route) {
  return (
    getMeaningfulRouteText(
      route?.service_display_name,
      route?.route_short_name,
    ) ||
    getMeaningfulRouteText(route?.route_long_name, route?.route_short_name) ||
    getMeaningfulRouteText(route?.route_desc, route?.route_short_name) ||
    route?.route_short_name ||
    route?.route_long_name ||
    ""
  );
}
